import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  container: {
    flex: 1,
    padding: theme.spacing[4],
  },
  button: {
    marginTop: theme.spacing[4],
  },
}));
